/*eslint eqeqeq: "off"*/
// React
import React from 'react';

// Components
import Modal2Component from 'shared/components/modal2/Modal2Component';
import PaymentIncludedTournamentsComponent from '../payment-included-tournaments/PaymentIncludedTournamentsComponent';
import PaymentInstallmentsComponent from '../payment-installments-tournaments/PaymentInstallmentsComponent';
import PrimaryButtonComponent from 'shared/components/primary-button/PrimaryButtonComponent';

// Styles
import './PaymentDetailsModalComponent.styles.css';

//i18
import { withTranslation } from 'react-i18next';

//Assets
import payment_icon from 'assets/images/payment_icon.png';

function PaymentDetailsModalComponent ( props ) {

    return(
        <Modal2Component
            isOpen={props.isOpen} 
            onClose={props.onClose}
            title={props.t('paymentDetailModal.modalTitle')}
            className="payment-details-modal"
        >
            <div className='payment-details-modal__container scroll'>
                <div className='payment-details-modal__title'>
                    <img src={payment_icon} alt=""/>
                    <div className='baloa-names'>{props.payment_details?.caption}</div>
                </div>
                <PaymentInstallmentsComponent
                    installments={ props.payment_details?.installments }
                    payment_type={ props.payment_details?.payment_type }
                    payment_state={ props.payment_details?.payment_state }
                    handleOnReceipt={ props.handleOnReceipt }
                    handleOnPay={ props.handleOnPay }
                />
                <PaymentIncludedTournamentsComponent
                    tournaments={props.payment_details?.tournaments}
                />
            </div>
        </Modal2Component>
    )
}

export default withTranslation('payments')(PaymentDetailsModalComponent);